module.exports = __webpack_public_path__ + "static/media/bg.98192044.svg";